firebird.factory('videoStatsQualityBarsService', [
    '$rootScope',
    '$window',
    '$interval',
    '$timeout',
    'configService',
    'logService',
    'socketService',
    'videoGlobalService',
    'attendeeListService',
    'contentService',
    'helperService',
    'avDeviceService',
    'meetingService',
    function (
        $rootScope,
        $window,
        $interval,
        $timeout,
        configService,
        logService,
        socketService,
        videoGlobalService,
        attendeeListService,
        contentService,
        helperService,
        avDeviceService,
        meetingService
    ) {
        var attendeesQualityDataLastReceived = {}; // saves quality data last received from server for each attendee
        var fakeMediaData = { audio: {}, video: {}, screen: {}, setQualityBarsUI: false }; // used to save media data and quality value that is set from labs ui. This data will be override the actual data
        var lastStatsReceived = null; // used to save last stats for calculating quality immediately when metrics are changed from labs playground and on slow link
        var slowLinkData = { audio: null, video: null, screen: null }; // any slow link data for tx
        var qualityBarsDataLastSent = {}; // saves quality data last sent to server
        var attrsToSend = ['audioTx', 'videoTx', 'screenTx']; // send these attributes to server.
        var attrsForSelf = ['audioTx', 'audioRx', 'videoTx', 'screenTx']; // attributes that are used for quality bars calculations, for self.
        let attrsForTooltip = ['audioTx', 'audioRx', 'videoTx', 'videoRx', 'screenTx', 'screenRx']; // attributes used for quality bars short tooltip creation.
        var currentContentOwnerId = 0;
        var service = {
            initialize: initialize
        };

        var self, $scope;

        return service;
        function initialize(selfParam) {
            self = selfParam;
            $scope = videoGlobalService.data.$scope;

            if (videoGlobalService.test) {
                $window = videoGlobalService.data.$window;
            }

            self.initStatsQualityBars = initStatsQualityBars;
            self.combineAndSendQualityBarsData = combineAndSendQualityBarsData;
            self.setQualityBarsAttrs = setQualityBarsAttrs;
            self.calculateMediaQuality = calculateMediaQuality;
            self.triggerQualityBars = triggerQualityBars;
            self.updateQualityOnSlowLink = updateQualityOnSlowLink;
            self.stopQualityStats = stopQualityStats;

            $scope.$on('attendee-partial-property', onAttendeePartialProperty);
            $rootScope.$on('remove-attendee', onRemoveAttendee);

            $scope.$on('content-initiating', onContentInitiating);
            $scope.$on('content-init-cancelled', onContentInitCancelled);
            $scope.$on('content-stopped', onContentStopped);
            $scope.$on('content-status', onContentStatus);

            $scope.$on('received-cpu-metrics-video-room', onReceivedCpuMetrics);

            $scope.$on('e2ee-enabled', onE2EEEnabled);
            $scope.$on('e2ee-disabled', onE2EEDisabled);

            $scope.$on('node-disconnected', onNodeDisconnected);
            $scope.$on('node-reconnected', onNodeReconnected);

            self.qualityBarsDefault = {
                enabled: false, // this cannot be modified via config value.
                log: false, // enable excessive logging for this module.
                audioMOS: true, // use MOS style calculation for audio
                delay: true, // checks for high delay
                jitter: true, // checks for high jitter
                bitrate: true, // checks if actual bitrate is acceptable on wrt available and desired bitrate
                areaReduction: false, // desired resolution to actual resolution
                expandedVideo: true, // checks if expanded video beyond its resolution based on area.
                videoLow: false, // if enabled it will checks if low performance mode is on and reduce quality by 80%
                framesLost: true, // frames lost due to dropped or not decoded
                frameRateReduction: true, // checks if actual frame rate is acceptable wrt desired frame rate
                qpSum: false, // not implemented yet.
                screenRxBWE: false, // whether to enable use of available bitrate for screen Rx.

                useWeights: false, // if false, then use minimum attr score.
                // if true, then weights of attrs in quality score.
                weights: {
                    audioTx: 3,
                    videoTx: 2,
                    screenTx: 2,
                    audioRx: 3,
                    videoRx: 1,
                    screenRx: 1
                },
                includeRx: true, // if true, include Rx stats for attendee quality calculation
                // autoHide valid values :: true (quality bars will hide after 5 seconds),
                // false (quality bars will always be visible) or
                // number (quality bars will be hidden after specified time in seconds)
                autoHide: 0,
                // Min quality bar value to enable autoHide.
                // Possible value :: number (If quality bars value is greater than or equal to this value,the quality bars will be displayed for the amount of time specified in seconds (autoHide)).
                // The value must be a number between 0 and 4.
                autoHideCutoff: 2,
                // if we enable this it increase the frequency of metrics (getStats) capture if lower quality is detected,
                // so that the value may be recovered quickly, instead of waiting for the next 10s interval
                quickRecovery: false,
                // interval for quick recovery, if true, in ms
                statsInterval: 2500,

                slowLink: true, // whether to use slow link events in determining self tx quality value
                slowLinkTimeout: 5000, // keep slow link event for up to 5s if no more slow link received.

                // whether to include desired bitrate in quality calculation when videoFilter is on.
                bitrateInVideoFilter: false,

                // delay has value X, and maps range [75, 150] to factors F [1, 0] for quality calculation,
                // i.e., if delay is 75, quality *= 1 (quality is unaffected), and if delay is 150, quality *= 0 (quality becomes 0)
                // this results in linear equations of the form F = A*X + B, the below table calculates A and B from cutoffs.
                // if cutoff values change then updateFactors/calculateFactors recalculate these.
                // ?qualityBars=delay:false,cutoff.jitter0:200,...
                cutoff: {
                    delay0: 400, // more than this means q=0
                    delay1: 150, // less than this does not affect q
                    delayA: 0, // FACTOR A of linear equation (A*X + B)
                    delayB: 0, // FACTOR B of linear equation (A*X + B)
                    jitter0: 200, // more than this means q=0
                    jitter1: 50, // less than this does not affect q
                    jitterA: 0, // FACTOR A of linear equation (A*X + B)
                    jitterB: 0, // FACTOR B of linear equation (A*X + B)
                    availableBitrate1: 1, // bitrate is 100% of available bitrate then q=1, less than this does not affect q
                    availableBitrate0: 1.5, // bitrate is 150% of available bitrate q=0, more than this means q=0
                    desiredBitrate0: 0.4, // bitrate is 40% of desired bitrate then q=0, less than this means q=0
                    desiredBitrate1: 0.8, // bitrate is 80% of available bitrate q=1, more than this does not affect q
                    areaReduction1: 0.9, // desired resolution is 90% of actual resolution q=1, more than this does not affect q
                    areaReduction0: 0.5, // desired resolution is 50% of actual resolution q=0, less than this means q=0
                    expandedVideo1: 1.5, // display size is 150% of video resolution q=1, less than this does not affect q
                    expandedVideo0: 3.0, // display size is 300% of video resolution q=0, more than this means q=0
                    framesLost1: 0.05, // 5% frames lost q=1
                    framesLost0: 0.3, // 30% frames lost q=0
                    frameRateReduction1: 0.5, // actual frame rate is at least 50% of desired frame rate q=1
                    frameRateReduction0: 0 // actual frame rate is 0% of desired frame rate q=0
                },
                // parsing may create new cutoff-screen, cutoff-video, etc.
                // mapping quality score (1-0) to quality bars (4, 3, 2, 1, 0)
                // [0.9, 0.6, 0.3, 0] => show 0 for quality value below 30%
                // [0.9, 0.4, 0, 0] => reserve 0 for disconnection, and show 1 for quality value below 40%
                breakPoints: [0.9, 0.4, 0, 0],
                cpuUsageThreshold: 60,

                // To display short QB tooltips, enabled by default
                shortTooltips: true,
                // cutoffs to add adjective in QB tooltip
                tooltipCutoff: Object.fromEntries(
                    attrsForTooltip.map(attr => {
                        return [
                            attr,
                            {
                                loss: 0.5, // value > loss => 'high' else 'some'
                                jitter: 0.5, // value > jitter => 'high' else 'some'
                                delay: 0.5, // value > delay => 'excessive' else 'high'
                                availableBitrate: 1.2, // value > availableBitrate => 'very poor' else 'poor'
                                desiredBitrate: 0.6 // value > desiredBitrate => 'poor' else 'very poor'
                            }
                        ];
                    })
                )
            };
            // from config value true, false or comma separated name1:value1,name2:value2,...
            self.qualityBarsConfig = Object.assign({}, self.qualityBarsDefault);
            // saves each media quality bars value for self
            self.qualityBarsData = {};
            self.isNodeDisconnected = false;

            // state for quick recovery if configured
            // last - last saved metrics data for internal use
            // timer - if active
            // pending - to avoid calling again while previous is pending
            // skipped - count of intervals which were skipped in timer handler
            self.qualityStats = { last: null, timer: null, pending: false, skipped: 0 };
        }

        function initStatsQualityBars() {
            if (meetingService.e2eeEnabled()) {
                return;
            }
            let qualityBars = configService.getValue('qualityBars');
            if (qualityBars) {
                Object.assign(self.qualityBarsConfig, self.qualityBarsDefault);
                if (qualityBars === 'true') {
                    self.qualityBarsConfig.enabled = true;
                } else if (qualityBars === 'false') {
                    self.qualityBarsConfig.enabled = false;
                } else {
                    // implicitly becomes enabled = true
                    self.setConfigObjectFromCSV(self.qualityBarsConfig, qualityBars, { create: true, convert: true }); // create if missing
                    self.qualityBarsConfig.enabled = true;
                }
                updateFactors(); // update the cutoff factors based on values.
                logQuality(`self.qualityBarsConfig configurations: `, self.qualityBarsConfig);
            } else {
                self.qualityBarsConfig.enabled = false;
            }
            sendQualityBarsConfig();
        }

        function updateQualityOnSlowLink(media, packetsLost) {
            if (!self.qualityBarsConfig.enabled || !self.qualityBarsConfig.slowLink) {
                return;
            }
            logQuality(`updateQualityOnSlowLink media=${media} packetsLost=${packetsLost}`);

            const now = Date.now();
            const slowLinkTimeout = self.qualityBarsConfig.slowLinkTimeout;
            // save slow link packet lost in slowLinkData which will be used later for quality calculation
            let data = slowLinkData[media];
            if (!data || data.end + slowLinkTimeout < now) {
                data = slowLinkData[media] = { start: now, count: 0, lost: 0 };
            }
            data.end = now;
            data.count++;
            data.lost += packetsLost;
            logQuality(`updateQualityOnSlowLink data=${JSON.stringify(data)}`);

            if (data.timer) {
                $timeout.cancel(data.timer);
                data.timer = null;
            }

            // Add timer function to clear slow link data after some time
            data.timer = $timeout(function () {
                if (slowLinkData[media]) {
                    logQuality(`updateQualityOnSlowLink deleting for ${media}`);
                    $timeout.cancel(slowLinkData[media].timer);
                    slowLinkData[media] = null;
                    updateAndSendQualityBarsData('slowLink');
                }
            }, slowLinkTimeout);

            // TODO: not sure if sending to server is desired here.
            updateAndSendQualityBarsData('slowLink');
        }

        function combineAndSendQualityBarsData(result, source) {
            if (!self.qualityBarsConfig.enabled) {
                return;
            }
            logQuality('combineAndSendQualityBarsData source=', source);
            saveMediaQualityBarsToLocalData(result);
            deleteMutedAttrs();
            combineMediaQualityForAllAttendees();
            sendQualityDataToServer();
        }

        // save qualityBars and quality attribute in media stats
        function setQualityBarsAttrs(stats, source) {
            lastStatsReceived = stats;

            // cleanup expired slowLink data.
            // TODO: this may not be needed due to timer based cleanup.
            let now = null;
            for (let media in slowLinkData) {
                if (slowLinkData[media]) {
                    if (!now) {
                        now = Date.now();
                    }
                    if (slowLinkData[media].end + self.qualityBarsConfig.slowLinkTimeout < now) {
                        slowLinkData[media] = null;
                    }
                }
            }

            Object.values(stats).map(item => {
                [item.qualityBars, item.quality] = calculateMediaQuality(item);
            });
        }

        function updateFactors() {
            let def = self.qualityBarsConfig.cutoff; // default cutoff
            ['cutoff', 'cutoff-screen', 'cutoff-audio', 'cutoff-video'].forEach(attr => {
                let cutoff = self.qualityBarsConfig[attr];
                if (cutoff) {
                    const props = {};
                    ['delay1', 'delay0', 'jitter1', 'jitter0'].forEach(name => {
                        props[name] = cutoff[name] === undefined ? def[name] : cutoff[name];
                    });

                    [cutoff.delayA, cutoff.delayB] = calculateFactors(props.delay1, 1, props.delay0, 1, 1, 0);
                    [cutoff.jitterA, cutoff.jitterB] = calculateFactors(props.jitter1, 1, props.jitter0, 1, 1, 0);
                }
            });
        }

        // function broadcasts enabled and autoHide properties (to be used in attendeeCtrl)
        // broadcast quality bars configuration to inform users in meeting if quality is enabled for self
        function sendQualityBarsConfig() {
            let { enabled, autoHide, autoHideCutoff, shortTooltips, tooltipCutoff } = self.qualityBarsConfig;
            self.qualityBarsConfig.autoHide = autoHide = !isNaN(parseFloat(autoHide))
                ? parseFloat('' + autoHide)
                : autoHide === true || autoHide === 'true'
                ? 5
                : false;

            $rootScope.$broadcast('set-qualitybars-config', {
                enabled,
                autoHide,
                autoHideCutoff,
                shortTooltips,
                tooltipCutoff
            });
            socketService.send({
                message: 'attendee-qualitybars-updated',
                data: {
                    qualityBars: { enabled: self.qualityBarsConfig.enabled }
                }
            });
        }

        // function saves property qualityBars in local qualityBarsData variable
        function saveMediaQualityBarsToLocalData(result) {
            logQuality('saveMediaQualityBarsToLocalData result: ', result);
            if (Array.isArray(result)) {
                result?.forEach(function (item) {
                    let mediaType = item.media === 'video' && item.screen ? 'screen' : item.media;
                    addMetricToLocalData(mediaType, item);
                });
            }
        }

        // function adds qualityBars values for each media to self.qualityBarsData
        function addMetricToLocalData(type, item) {
            let result = { qualityBars: item.qualityBars, quality: item.quality };
            if (item.dir === 'inbound') {
                const mediaType = type + 'Rx';
                if (type !== 'audio') {
                    if (!self.qualityBarsData[mediaType]) {
                        self.qualityBarsData[mediaType] = {};
                    }
                    let attendantId = item.attendee;
                    if (type === 'screen' && attendantId && self.isScreenshareId(attendantId)) {
                        attendantId = self.getAttendantIdFromScreenshareId(attendantId);
                    }
                    self.qualityBarsData[mediaType][attendantId] = {
                        ...self.qualityBarsData[mediaType][attendantId],
                        ...result
                    };
                } else {
                    self.qualityBarsData[mediaType] = { ...self.qualityBarsData[mediaType], ...result };
                }
            } else if (item.dir === 'outbound') {
                self.qualityBarsData[type + 'Tx'] = { ...self.qualityBarsData[type + 'Tx'], ...result };
            }
        }

        // function called after collecting local stats
        // it combines quality values of media being shared by each attendee
        function combineMediaQualityForAllAttendees() {
            let attendeesQuality = new Map();
            let attendeeList = attendeeListService.getAttendeeList();
            attendeeList?.forEach(attendee => {
                let isSelf = attendee.attendantId === self.attendantId;
                const [qualityBars, quality] = isSelf ? combineSelfQuality() : combineAttendeesQuality(attendee);
                // increase the frequency of metrics (getStats) capture if lower quality is detected,
                // so that the value may be recovered quickly, instead of waiting for the next 10s interval.
                if (isSelf && self.sendStatsTimer && self.qualityBarsConfig.quickRecovery) {
                    if (qualityBars < 3 && !self.qualityStats.timer) {
                        startQualityStats();
                    } else if (qualityBars >= 3 && self.qualityStats.timer) {
                        stopQualityStats();
                    }
                }
                attendeesQuality.set(attendee.attendantId, { qualityBars, quality });
            });
            $rootScope.$broadcast(
                'update-attendees-quality',
                attendeesQuality,
                {
                    [self.attendantId]: self.qualityBarsData,
                    ...attendeesQualityDataLastReceived
                },
                null
            );
        }

        function startQualityStats() {
            if (!self.qualityStats.timer) {
                self.qualityStats.last = {};
                self.qualityStats.skipped = 0;
                self.qualityStats.pending = false;
                self.qualityStats.timer = $interval(onQualityStatsTimeout, self.qualityBarsConfig.statsInterval);
                onQualityStatsTimeout();
            }
        }

        function stopQualityStats() {
            if (self.qualityStats.timer) {
                $interval.cancel(self.qualityStats.timer);
                self.qualityStats.last = {};
                self.qualityStats.timer = null;
                self.qualityStats.pending = false;
                self.qualityStats.skipped = 0;
            }
        }

        // similar to onSendStatsTimeout but only for quality bars.
        function onQualityStatsTimeout() {
            if (self.qualityStats.pending) {
                self.qualityStats.skipped++;
                return; // wait for previous callback to complete.
            }

            // duration for which this calculation is called for.
            const interval = self.qualityBarsConfig.statsInterval * (1 + self.qualityStats.skipped);
            self.qualityStats.skipped = 0;
            self.qualityStats.pending = true;

            self.calculateMediaQualityMetrics(
                self.qualityStats.last,
                function (result) {
                    self.qualityStats.pending = false;
                    if (self.qualityStats.timer) {
                        self.combineAndSendQualityBarsData(result, 'qualityStats');
                    }
                },
                {
                    interval: interval,
                    candidates: !!self.adjustOnAvailableBandwidth,
                    bytes: 'raw',
                    firsttime: true,
                    flat: true,
                    fixframerate: true,
                    cumulative: false,
                    qualityBar: !!self.qualityStats.timer,
                    sendstats: false // do not send to FireFly.
                }
            );
        }

        // function to combine qualityBar values to get final result
        // Function returns min_or_avg_quality_bar_value(audioTx, audioRx, videoTx, screenTx)
        function combineSelfQuality() {
            let qualityBarsScores = getValuesFromData(self.qualityBarsData, attrsForSelf, 'qualityBars');
            let qualityScores = getValuesFromData(self.qualityBarsData, attrsForSelf, 'quality');
            logQuality(
                `combineSelfQuality qualityBarsScores ${JSON.stringify(
                    qualityBarsScores
                )} qualityScores ${JSON.stringify(qualityScores)}`
            );
            return [calculateMinValueIfPresent(qualityBarsScores), calculateMinValueIfPresent(qualityScores, true)];
        }

        // function to combine received qualityBars values to get final result
        // which is Tx values received from server and locally calculated Rx
        function combineAttendeesQuality(attendee) {
            if (self.isNodeDisconnected) {
                return [0, 0];
            }
            function getScores(metric) {
                let videoRx = self.qualityBarsData?.videoRx?.[attendee.attendantId]?.[metric];
                let screenRx = self.qualityBarsData?.screenRx?.[attendee.attendantId]?.[metric];
                let attendeeQualityBarsData = attendee?.qualityBars?.data;

                let scoresTx = getValuesFromData(attendeeQualityBarsData, attrsForSelf, metric);
                return { videoRx, screenRx, ...scoresTx };
            }
            let qualityBarsScores = getScores('qualityBars');
            let qualityScores = getScores('quality');

            logQuality(
                `combineAttendeesQuality ${attendee.screenName} qualityBarsScores ${JSON.stringify(
                    qualityBarsScores
                )} qualityScores ${JSON.stringify(qualityScores)}`
            );
            return [calculateMinValueIfPresent(qualityBarsScores), calculateMinValueIfPresent(qualityScores, true)];
        }

        // return the minimum value (or weighted average depending on configuration) from scores dict if present, else null.
        function calculateMinValueIfPresent(scoresObj, round2DecimalPlaces) {
            const config = self.qualityBarsConfig;
            if (config.useWeights) {
                const entries = Object.entries(scoresObj).filter(nv => nv[1] !== undefined && nv[1] !== null);
                const numerator = entries.map(([attr, score]) => config.weights[attr] * score);
                const denominator = entries.map(([attr, score]) => config.weights[attr]);
                const adder = arr => arr.reduce((a, b) => a + b, 0);
                const denomSum = adder(denominator);
                const avg = adder(numerator) / denomSum;
                const score =
                    numerator.length > 0 && denominator.length > 0 && denomSum > 0
                        ? round2DecimalPlaces
                            ? Number(avg.toFixed(2))
                            : Math.round(avg)
                        : null;
                return score;
            } else {
                const scores = Object.values(scoresObj).filter(score => score !== undefined && score !== null);
                return scores.length ? Math.min(...scores) : null;
            }
        }

        // return dict of qualityBars values indexed by attr from the stats data object.
        function getValuesFromData(stats, attrs, metric) {
            return !stats
                ? {}
                : Object.fromEntries(attrs.filter(attr => stats[attr]).map(attr => [attr, stats[attr][metric]]));
        }

        // Sends media quality value and metrics effecting media quality to the server for broadcasting in the meeting
        function sendQualityDataToServer() {
            if (self.qualityBarsData) {
                let qualityBarsDataToSend = Object.fromEntries(
                    attrsToSend
                        .filter(attr => self.qualityBarsData[attr])
                        .map(attr => {
                            return [
                                attr,
                                {
                                    ...self.qualityBarsData[attr]
                                }
                            ];
                        })
                );

                if (!helperService.isObjectEqual(qualityBarsDataToSend, qualityBarsDataLastSent)) {
                    qualityBarsDataLastSent = qualityBarsDataToSend;
                    logQuality('send quality data to server: ', qualityBarsDataToSend);
                    socketService.send({
                        message: 'attendee-qualitybars-updated',
                        data: {
                            qualityBars: { data: qualityBarsDataToSend }
                        }
                    });
                }
            }
        }

        function isPublishMediaInitiated(is_screen) {
            const plugin = is_screen ? self.screenshare : self.videoroom;
            return plugin?.state?.mediaInitiated;
        }

        // function deletes media data that has been muted from quality bars data and metric causing quality degradation to update quality bars and tooltip
        // use case: user turns on video - video quality calculated is 3. Later, user mutes video in this case the calculated quality should be deleted.
        function deleteMutedAttrs() {
            let attendeeList = attendeeListService.getAttendeeList();
            attendeeList.forEach(attendee => {
                let isSelf = attendee.attendantId === self.attendantId;
                const metricsCausingDegrade = attendee?.qualityBars?.data;
                // which property to delete, if true.
                let toDelete = isSelf
                    ? {
                          audioTx:
                              attendee.isSelfMuted || attendee.switchedToPhone || avDeviceService.isAudioDisconnected(),
                          audioRx: attendee.switchedToPhone,
                          videoTx: attendee.isVideoMuted || !isPublishMediaInitiated(),
                          screenTx: self.screenshareState !== 'active' || !isPublishMediaInitiated(true)
                      }
                    : {
                          videoRx: attendee.isVideoMuted || self.isVideoTogglePaused() || self.pauseOnBackground.paused,
                          screenRx:
                              !(
                                  (contentService.getIsScreenShareActive() &&
                                      attendee.attendantId === currentContentOwnerId) ||
                                  attendee.hasScreenVideo
                              ) || self.isVideoTogglePaused(true)
                      };

                Object.entries(toDelete)
                    .filter(nv => nv[1])
                    .map(nv => nv[0])
                    .forEach(
                        isSelf
                            ? property => {
                                  delete self.qualityBarsData?.[property];
                                  delete metricsCausingDegrade?.[property];
                              }
                            : property => {
                                  delete self.qualityBarsData?.[property]?.[attendee.attendantId];
                                  delete metricsCausingDegrade?.[property];
                              }
                    );
            });
        }

        // mediaData is for audioTx, videoTx, etc.
        function calculateMediaQuality(mediaData) {
            const type = mediaData.media === 'video' && mediaData.screen ? 'screen' : mediaData.media;
            mediaData = setFakeValues(mediaData);
            let { packets, dir, attendee } = mediaData;

            if (dir === 'inbound' && type !== 'audio' && !self.qualityBarsConfig.includeRx) {
                logQuality(`  null: do not include Rx`);
                return [null, null];
            }

            // Delete '100' from attendee id (this is present in case of screen share)
            if (attendee && self.isScreenshareId(attendee)) {
                attendee = self.getAttendantIdFromScreenshareId(attendee);
            }

            const attendantId = attendee === undefined ? self.attendantId : parseInt(attendee);
            logQuality(`calculateMediaQuality type: ${type} mediaDir: ${dir} attendantId ${attendantId}`);

            let metricQuality = 0;
            const key = type + (dir === 'inbound' ? 'Rx' : 'Tx');
            initMetricsCausingQualityDegradation(attendantId, key);

            // When this flag is set quality bar value is set from the labs UI
            if (fakeMediaData.setQualityBarsUI !== false && attendantId === self.attendantId) {
                const breakPoints = self.qualityBarsConfig.breakPoints;
                // send fake quality data
                const quality =
                    fakeMediaData.setQualityBarsUI == 0
                        ? 0
                        : breakPoints[breakPoints.length - fakeMediaData.setQualityBarsUI] + 0.1;

                return [fakeMediaData.setQualityBarsUI, quality];
            }

            const unavailableData = !mediaData || Object.keys(mediaData).length <= 0;
            const audioPlugin = self.sipcall;
            const audioNotStarted =
                type === 'audio' &&
                !packets &&
                (!audioPlugin ||
                    (dir === 'inbound' && !audioPlugin.receiveInitiated) ||
                    (dir === 'outbound' && !audioPlugin.state?.mediaInitiated));

            if (unavailableData || audioNotStarted) {
                logQuality(`  null: unavailable data ${unavailableData} or audioNotStarted ${audioNotStarted}`);
                return [null, null];
            }

            const noPackets = !packets,
                frozenVideo = type === 'video' && isVideoFrozen(mediaData, dir),
                brokenSource = self.brokenMediaSource.detected;
            if (noPackets || frozenVideo || (brokenSource && dir === 'outbound') || self.isNodeDisconnected) {
                logQuality(
                    `  0: no packets ${noPackets}, frozen video ${frozenVideo} or broken source ${brokenSource}`
                );
                return [0, 0];
            }

            // calculate quality q between 0-1
            logQuality(`  q between 0-1`);
            let cutoff = self.qualityBarsConfig.cutoff;
            if (self.qualityBarsConfig['cutoff-' + type] !== undefined) {
                cutoff = Object.assign({}, cutoff, self.qualityBarsConfig['cutoff-' + type]);
            }
            const config = self.qualityBarsConfig;

            const { flaw, delay, jitter } = calculateFlawDelayJitter(mediaData);
            Object.assign(mediaData, { flaw, delay, jitter });
            let quality =
                type === 'audio' && config.audioMOS
                    ? calculateMosQuality(flaw, delay, jitter, packets)
                    : calculateLossQuality(flaw, packets);
            saveMetricIfQualityDegrades(attendantId, key, quality, { LOSS: (1 - quality) * 100 });

            const { availableBitrate, bitrate } = mediaData;
            const allowBitrate = type !== 'screen' || dir !== 'inbound' || config.screenRxBWE;
            if (allowBitrate && config.bitrate && availableBitrate) {
                metricQuality = linearFactorAlt(
                    cutoff.availableBitrate1 * availableBitrate,
                    cutoff.availableBitrate0 * availableBitrate,
                    bitrate
                );
                saveMetricIfQualityDegrades(attendantId, key, metricQuality, {
                    AVAILABLE_BITRATE: (bitrate / availableBitrate) * 100
                });
                // q = F5(q) # linear factor if actual bitrate is 100-150% of available bitrate
                quality *= metricQuality;
                logQuality(
                    `    bitrate :: availableBitrate ${availableBitrate} :: metricQuality ${metricQuality} :: quality: ${quality}`
                );
            }

            if (type === 'video' || type === 'screen' || (type == 'audio' && !config.audioMOS)) {
                // q := F4(q) # linear factor for high delay (75-150ms) or high jitter (50-150ms)
                if (config.delay) {
                    metricQuality = linearFactor(cutoff.delayA, cutoff.delayB, delay);
                    saveMetricIfQualityDegrades(attendantId, key, metricQuality, { DELAY: delay });
                    quality *= metricQuality;
                    logQuality(`    delay ${delay} :: metricQuality ${metricQuality} :: quality: ${quality}`);
                }
                if (config.jitter) {
                    metricQuality = linearFactor(cutoff.jitterA, cutoff.jitterB, jitter);
                    saveMetricIfQualityDegrades(attendantId, key, metricQuality, { JITTER: jitter });
                    quality *= metricQuality;
                    logQuality(`    jitter ${jitter} :: metricQuality ${metricQuality} :: quality: ${quality}`);
                }
            }
            if (type === 'video' || type === 'screen') {
                if (dir === 'outbound') {
                    const { fpsCapture, frameRate } = mediaData;
                    if (config.frameRateReduction && typeof fpsCapture === 'number') {
                        // q := F10(q) # linear factor for frame rate reduction from desired.
                        metricQuality = linearFactorAlt(
                            fpsCapture * cutoff.frameRateReduction1,
                            fpsCapture * cutoff.frameRateReduction0,
                            frameRate
                        );
                        saveMetricIfQualityDegrades(attendantId, key, metricQuality, {
                            FRAME_RATE_REDUCTION: (1 - frameRate / fpsCapture) * 100
                        });
                        quality *= metricQuality;
                        logQuality(
                            `    frameRateReduction :: fpsCapture ${fpsCapture} frameRate ${frameRate} :: metricQuality ${metricQuality} :: quality: ${quality}`
                        );
                    }
                } else if (dir === 'inbound') {
                    if (config.framesLost) {
                        const { framesReceived, framesDecoded, framesDropped, frameRate } = mediaData;
                        // q := F9(q) # linear factor for frames lost due to dropped or not decoded 0-15
                        const framesLost = Math.max(0, framesReceived - framesDecoded + framesDropped);
                        metricQuality = linearFactorAlt(
                            (frameRate * cutoff.framesLost1 * self.sendStatsInterval) / 1000,
                            (frameRate * cutoff.framesLost0 * self.sendStatsInterval) / 1000,
                            framesLost
                        );
                        saveMetricIfQualityDegrades(attendantId, key, metricQuality, {
                            FRAMES_LOST: (framesLost / framesReceived) * 100
                        });
                        quality *= metricQuality;
                        logQuality(
                            `    framesLost :: framesReceived ${framesReceived} framesDecoded ${framesDecoded} framesDropped ${framesDropped} frameRate ${frameRate} framesLost ${framesLost} :: metricQuality ${metricQuality} :: quality: ${quality}`
                        );
                    }
                }
            }
            if (type === 'video') {
                if (dir === 'outbound') {
                    // Reduce 20% quality if videoLow is triggered.
                    if (config.videoLow && self.getIsVideoLow()) {
                        quality *= 0.8;
                        saveMetricIfQualityDegrades(attendantId, key, quality, { VIDEO_LOW: '' });
                    }
                    const { bitrate, bitrateDesired, height, width, frameHeight, frameWidth } = mediaData;
                    const hasCustomStream = self.videoroom && self.videoroom.hasCustomStream;
                    const includeBitrate = config.bitrate && (config.bitrateInVideoFilter || !hasCustomStream);
                    if (includeBitrate && bitrateDesired) {
                        // q := F6(q) # linear factor if actual bitrate is 80-40% of desired bitrate
                        metricQuality = linearFactorAlt(
                            cutoff.desiredBitrate1 * bitrateDesired,
                            cutoff.desiredBitrate0 * bitrateDesired,
                            bitrate
                        );
                        saveMetricIfQualityDegrades(attendantId, key, metricQuality, {
                            DESIRED_BITRATE: (bitrate / bitrateDesired) * 100
                        });
                        quality *= metricQuality;
                        logQuality(
                            `    bitrate :: bitrateDesired ${bitrateDesired} bitrate ${bitrate} :: metricQuality ${metricQuality} :: quality: ${quality}`
                        );
                    } else {
                        logQuality('    bitrate :: not using bitrateDesired');
                    }
                    if (config.areaReduction && height && width && frameHeight && frameWidth) {
                        // reduce by linear factor of area reduction from desired resolution to actual resolution.
                        const actualResolution = frameHeight * frameWidth,
                            desiredResolution = height * width;
                        metricQuality = linearFactorAlt(
                            desiredResolution * cutoff.areaReduction1,
                            desiredResolution * cutoff.areaReduction0,
                            actualResolution
                        );
                        saveMetricIfQualityDegrades(attendantId, key, metricQuality, {
                            AREA_REDUCTION: (1 - actualResolution / desiredResolution) * 100
                        });
                        quality *= metricQuality;
                        logQuality(
                            `    areaReduction :: desiredResolution ${desiredResolution} actualResolution ${actualResolution} :: metricQuality ${metricQuality} :: quality: ${quality}`
                        );
                    }
                } else if (dir === 'inbound') {
                    if (config.expandedVideo) {
                        // q := F8(q) # linear factor for expanded video beyond its resolution based on area.
                        const element = getVideoElement(mediaData.attendee);
                        if (element && !self.isVideoTogglePaused() && !self.pauseOnBackground.paused) {
                            // this is only for webcam, not screen.
                            const { frameHeight, frameWidth } = mediaData,
                                displaySize = Math.sqrt(element.clientHeight * element.clientWidth),
                                actualResolution = Math.sqrt(frameHeight * frameWidth);
                            metricQuality = linearFactorAlt(
                                actualResolution * cutoff.expandedVideo1,
                                actualResolution * cutoff.expandedVideo0,
                                displaySize
                            );
                            saveMetricIfQualityDegrades(attendantId, key, metricQuality, {
                                EXPANDED_VIDEO: (displaySize / actualResolution) * 100
                            });
                            quality *= metricQuality;
                            logQuality(
                                `    expandedVideo :: actualResolution ${actualResolution} displaySize ${displaySize} :: metricQuality ${metricQuality} :: quality: ${quality}`
                            );
                        }
                    }
                }
            }
            quality = Number(quality.toFixed(2));
            const bars = scaleQualityToBars(quality);
            logQuality(`  q=${Math.round(quality * 100)}% (${bars})`);
            return [bars, quality];
        }

        // override fake values set from labs playground in mediaData
        function setFakeValues(mediaData) {
            let data = Object.assign({}, mediaData);
            const type = mediaData.media === 'video' && mediaData.screen ? 'screen' : mediaData.media;
            if (fakeMediaData[type]) {
                data = { ...mediaData, ...fakeMediaData[type] };
            }
            return data;
        }

        // initializes metrics causing quality degradation which is saved in self.qualityBarsData
        // key - property to init (e.g. audioTx, videoTx)
        function initMetricsCausingQualityDegradation(attendeeId, key) {
            // const attendee = self.findAttendee(self.attendantId);
            if (self.qualityBarsData) {
                if (attendeeId === self.attendantId) {
                    self.qualityBarsData[key] = {};
                } else {
                    if (attendeeId !== self.attendantId) {
                        self.qualityBarsData[key] = {
                            [attendeeId]: {}
                        };
                    }
                }
            }
        }

        function isVideoFrozen(item, mediaDir) {
            if (mediaDir === 'outbound') {
                if (self.videoroom && !self.republishing && item.frameRate <= 0) {
                    return true;
                }
            } else if (mediaDir === 'inbound') {
                if (!item.paused && (!self.layoutPage || !item.disabled)) {
                    if (item.framesDecoded === 0) {
                        return true;
                    }
                }
            }
            return false;
        }

        function calculateFlawDelayJitter(mediaData) {
            let { media, rttDelay, jitterBufferDelay, candidatePairs, jitter = 0 } = mediaData;

            // accumulate multiple items of same interval
            let attrs = {};
            ['packets', 'bytes', 'bitrate', 'firCount', 'pliCount', 'nackCount', 'packetsLost'].forEach(function (
                attr
            ) {
                attrs[attr] = mediaData[attr] || 0;
            });

            let delay =
                (rttDelay && rttDelay / 2) ||
                (typeof jitterBufferDelay === 'number' &&
                    typeof candidatePairs?.currentRoundTripTime === 'number' &&
                    jitterBufferDelay + candidatePairs?.currentRoundTripTime / 2) ||
                0;

            let lost = attrs.packetsLost || 0;
            const type = media === 'video' && mediaData.screen ? 'screen' : media; // also screen
            if (slowLinkData[type]) {
                logQuality(`    slowLink: ${slowLinkData[type].lost}, lost ${lost} ${type}`);
                if (lost < slowLinkData[type].lost) {
                    // use slowLink's lost information if more.
                    lost = slowLinkData[type].lost;
                }
            }

            let flaw = 0;
            switch (media) {
                case 'audio':
                    flaw = lost;
                    break;
                case 'video':
                    flaw = Math.max(
                        Math.max(attrs.firCount || 0, attrs.pliCount || 0) + Math.round((attrs.nackCount || 0) / 10),
                        lost
                    );
                    break;
                default:
                    break;
            }
            logQuality(`    flaw: ${flaw} delay: ${delay} jitter: ${jitter}`);
            return { flaw, delay, jitter };
        }

        function calculateMosQuality(flaw, delay, jitter, packets) {
            let lossrate = Math.min(1, flaw / (packets || 1));
            let latency = (delay || 0) + (jitter || 0) * 2 + 20.0;
            let R = latency < 160 ? 93.2 - latency / 40 : 93.2 - (latency - 120) / 10;
            R = R - 2.5 * lossrate * 100;
            return Math.round(Math.max(Math.min(R + 7.8, 100), 0)) / 100;
        }

        function calculateLossQuality(flaw, packets) {
            let lossrate = Math.min(1, flaw / (packets || 1));
            return (Math.max(1 - lossrate, 0.9) - 0.9) * 10;
        }

        // save metrics causing quality degradation in attendee object, this is later used to show tooltip for quality bars
        function saveMetricIfQualityDegrades(attendeeId, key, quality, metricsCausingDegrade) {
            const bestQualityValue = self.qualityBarsConfig.breakPoints[0];
            if (quality < bestQualityValue) {
                let qualityBarsData = self.qualityBarsData;
                let exitingMetrics = {};
                if (attendeeId !== self.attendantId) {
                    exitingMetrics = qualityBarsData[key][attendeeId];
                    qualityBarsData[key][attendeeId] = { ...exitingMetrics, ...metricsCausingDegrade };
                } else {
                    exitingMetrics = qualityBarsData[key];
                    qualityBarsData[key] = { ...exitingMetrics, ...metricsCausingDegrade };
                }
                logQuality('saveMetricIfQualityDegrades qualityBarsData: ', attendeeId, key, qualityBarsData);
            }
        }

        function getVideoElement(attendantId) {
            return $window.$('#videoroom-videos > div.remote[enable="true"][user="' + attendantId + '"] > video')?.[0];
        }

        function scaleQualityToBars(quality) {
            return quality === 0
                ? self.qualityBarsConfig.breakPoints[2] === 0
                    ? 1
                    : 0
                : self.qualityBarsConfig.breakPoints.findIndex(breakPoint => quality >= breakPoint) * -1 + 4;
        }

        // solves equation 1=ax+b and 0=ay+b
        function linearFactorAlt(a, c, value) {
            let [a1, b1] = calculateFactors(a, 1, c, 1, 1, 0);
            logQuality(`        linearFactorAlt a1: ${a1} b1: ${b1}`);
            return linearFactor(a1, b1, value);
        }

        // calculates a, b values for linear equation y = ax + b
        function calculateFactors(a, b, c, d, e, f) {
            let det = a * d - b * c;
            if (!det) {
                return [0, 0];
            }
            let x = (d * e - b * f) / det;
            let y = (a * f - c * e) / det;
            return [x, y];
        }

        // linear factor is typically a function y = ax + b
        // such that the input range map to the output range.
        // e.g., function for high delay (75-100ms) => (1-0) can be obtained by solving:
        // 1 = a*75+b and 0 = a*100 + b => a = -0.04, b = 4, so function becomes
        // F(x) = Math.min(1, Math.max(0, 4 - 0.04*x))) to limit within 0-1
        function linearFactor(a1, b1, value) {
            return Math.min(1, Math.max(0, b1 + a1 * value));
        }

        // function called when quality bars data is received from server
        // It combines quality bar values and broadcast update-attendees-quality event to update quality bar and tooltip
        function onAttendeePartialProperty(e, data) {
            if (!self.qualityBarsConfig.enabled) {
                return;
            }
            if (
                data &&
                data.propName === 'qualityBars' &&
                data.propValue &&
                data.attendantId &&
                data.attendantId !== self.attendantId
            ) {
                const attendantId = data.attendantId;
                const attendee = self.findAttendee(attendantId);
                if (
                    attendee &&
                    !helperService.isObjectEqual(attendeesQualityDataLastReceived[attendantId], data.propValue.data)
                ) {
                    attendeesQualityDataLastReceived[attendantId] = data.propValue.data;
                    let [qualityBars, quality] = combineAttendeesQuality(attendee);
                    const attendeeQuality = new Map();
                    attendeeQuality.set(attendantId, { qualityBars, quality });
                    $rootScope.$broadcast(
                        'update-attendees-quality',
                        attendeeQuality,
                        {
                            [self.attendantId]: self.qualityBarsData,
                            ...attendeesQualityDataLastReceived
                        },
                        attendantId
                    );
                }
            }
        }

        // function is called from labs playground
        // this is for testing various metrics causing quality degradation
        // function saves metrics values received in param: data
        // these values are later used to overrides media stats for simulating quality degardation
        function triggerQualityBars(data) {
            const { media, attr, value } = data;
            const mediaData = {
                availableBitrate: 1500,
                bitrateDesired: 1000,
                fpsCapture: 30,
                framesReceived: 600,
                frameRate: 60,
                width: 640,
                height: 480
            };
            switch (attr) {
                case 'set-quality-bars-ui':
                    if (value === null) {
                        fakeMediaData.setQualityBarsUI = false;
                    } else {
                        fakeMediaData.setQualityBarsUI = value;
                    }
                    break;
                case 'reset':
                    fakeMediaData.setQualityBarsUI = false;
                    setFakeMediaData(media, {}, true);
                    break;
                case 'loss':
                    if (value === null) {
                        delete fakeMediaData[media].packetsLost;
                        delete fakeMediaData[media].packets;
                    } else {
                        setFakeMediaData(media, { packetsLost: parseFloat(value), packets: 100 });
                    }
                    break;
                case 'delay':
                    if (value === null) {
                        delete fakeMediaData[media].rttDelay;
                    } else {
                        setFakeMediaData(media, { rttDelay: parseFloat(value) * 2 });
                    }
                    break;
                case 'jitter':
                    if (value === null) {
                        delete fakeMediaData[media].jitter;
                    } else {
                        setFakeMediaData(media, { jitter: parseFloat(value) });
                    }
                    break;
                case 'available-bitrate': {
                    if (value === null) {
                        delete fakeMediaData[media].availableBitrate;
                        delete fakeMediaData[media].bitrate;
                    } else {
                        const { availableBitrate } = mediaData;
                        setFakeMediaData(media, {
                            availableBitrate,
                            bitrate: (availableBitrate * parseFloat(value)) / 100
                        });
                    }
                    break;
                }
                case 'desired-bitrate': {
                    if (value === null) {
                        delete fakeMediaData[media].bitrateDesired;
                        delete fakeMediaData[media].bitrate;
                    } else {
                        const { bitrateDesired } = mediaData;
                        setFakeMediaData(media, {
                            bitrateDesired,
                            bitrate: (bitrateDesired * parseFloat(value)) / 100
                        });
                    }
                    break;
                }
                case 'framerate': {
                    if (value === null) {
                        delete fakeMediaData[media].fpsCapture;
                        delete fakeMediaData[media].frameRate;
                    } else {
                        const { fpsCapture } = mediaData;
                        setFakeMediaData(media, {
                            fpsCapture,
                            frameRate: (fpsCapture * parseFloat(value)) / 100
                        });
                    }
                    break;
                }
                case 'frames-lost': {
                    if (value === null) {
                        delete fakeMediaData[media].framesReceived;
                        delete fakeMediaData[media].framesDecoded;
                        delete fakeMediaData[media].framesDropped;
                        delete fakeMediaData[media].frameRate;
                    } else {
                        const { framesReceived, frameRate } = mediaData;
                        setFakeMediaData(data.media, {
                            framesReceived,
                            framesDecoded: framesReceived * (1 - parseFloat(value) / 100) + 10,
                            framesDropped: 10,
                            frameRate
                        });
                    }
                    break;
                }
                case 'area-reduction': {
                    if (value === null) {
                        delete fakeMediaData[media].frameWidth;
                        delete fakeMediaData[media].frameHeight;
                        delete fakeMediaData[media].height;
                        delete fakeMediaData[media].width;
                    } else {
                        const { width, height } = mediaData;
                        setFakeMediaData(data.media, {
                            frameWidth: width,
                            frameHeight: height * (1 - parseFloat(value) / 100),
                            height,
                            width
                        });
                    }
                    break;
                }
            }
            updateAndSendQualityBarsData('trigger');
        }

        function updateAndSendQualityBarsData(reason) {
            if (lastStatsReceived) {
                self.setQualityBarsAttrs(lastStatsReceived, reason);
                self.combineAndSendQualityBarsData(lastStatsReceived, reason);
            }
        }

        function setFakeMediaData(media, data, reset = false) {
            logQuality(`setFakeMediaData ${media} ${reset}`);
            if (!reset && fakeMediaData[media]) {
                Object.assign(fakeMediaData[media], data);
            } else if (reset && fakeMediaData[media]) {
                fakeMediaData[media] = {};
            } else {
                Object.assign(fakeMediaData, { audio: {}, video: {}, screen: {} });
            }
            logQuality('setFakeMediaData fakeMediaData:', fakeMediaData);
        }

        function onContentInitiating(e, data) {
            currentContentOwnerId = data.ownerID;
        }

        function onContentInitCancelled(e, data) {
            currentContentOwnerId = 0;
        }

        function onContentStopped(e, data) {
            currentContentOwnerId = 0;
        }

        function onContentStatus(e, data) {
            if (data.state === 'running') {
                currentContentOwnerId = data.ownerID;
            }
            if (data.state === 'stopped') {
                currentContentOwnerId = 0;
            }
        }

        function onReceivedCpuMetrics(e, transformed) {
            if (transformed.cpuLoadTotal >= self.qualityBarsConfig.cpuUsageThreshold) {
                self.qualityBarsData.cpuUsage = transformed.cpuLoadTotal;
            } else {
                delete self.qualityBarsData.cpuUsage;
            }
        }

        function onE2EEEnabled() {
            self.qualityBarsConfig.enabled = false;
        }

        function onE2EEDisabled() {
            let qualityBars = configService.getValue('qualityBars');
            self.qualityBarsConfig.enabled = qualityBars && qualityBars !== 'false';
        }

        function onRemoveAttendee(e, data) {
            delete attendeesQualityDataLastReceived[data.attendantId];
        }

        function onNodeDisconnected() {
            logQuality('Node disconnected');
            self.isNodeDisconnected = true;
            // self.onSendStatsTimeout();
        }

        function onNodeReconnected() {
            logQuality('Node reconnected');
            sendQualityBarsConfig();
            self.isNodeDisconnected = false;
        }

        // excessive logging in this module if log flag is enabled.
        function logQuality() {
            if (self.qualityBarsConfig.log) {
                let args = Array.prototype.slice.call(arguments);
                args.unshift('QUALITY');
                logService.log.apply(logService, args);
            }
        }
    }
]);
